/**
 * ROUTE-2 paint fence — exiting primary stage is immediately non-interactive.
 * Soft≠Live: no backend paths in the veil; operator labels only.
 */
import { useEffect, useRef } from "react";
import { usePresence } from "framer-motion";
import { html, M, FADE } from "./ui.js";

const PRIMARY_LABEL = Object.freeze({
  ops: "Operations",
  response: "Response",
  dispatch: "Resources",
  skills: "Skills",
  cameras: "Cameras Live",
  prepare: "Prepare",
  machine: "Machine",
  activate: "Activate",
  automations: "Automations",
  ota: "OTA",
  settings: "Settings",
  sa: "Platform",
  fleet: "Fleet",
  edge: "Edge",
  control: "Control",
  auth: "Sign in",
  system: "System",
});

export function primaryOf(route) {
  const seg = String(route || "").split("/");
  return seg[1] || "ops";
}

export function labelOfPrimary(id) {
  const k = String(id || "").trim();
  return PRIMARY_LABEL[k] || "Console";
}

/** Fence leaving stage: inert + aria-hidden + no pointer events (P1-ROUTE-5). */
export function FencedStage({ children }) {
  const [isPresent] = usePresence();
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!isPresent) {
      el.setAttribute("inert", "");
      el.setAttribute("aria-hidden", "true");
      el.setAttribute("data-cmc-route-fence", "exit");
      el.style.pointerEvents = "none";
    } else {
      el.removeAttribute("inert");
      el.removeAttribute("aria-hidden");
      el.removeAttribute("data-cmc-route-fence");
      el.style.pointerEvents = "";
    }
  }, [isPresent]);

  return html`<${M.div} ref=${ref}
      className="page__stage"
      data-cmc-route-fence=${isPresent ? "live" : "exit"}
      initial=${{ opacity: 0, y: 6 }}
      animate=${{ opacity: 1, y: 0 }}
      exit=${{ opacity: 0, y: -4 }}
      transition=${FADE}>
    ${children}
  <//>`;
}

/**
 * ROUTE-2 paint veil — SEALED (2026-08-13).
 * Kept exported for contract/import stability; never paints. Callers must pass
 * show=false / omit the component. Do not re-enable without owner re-auth.
 */
export function RoutePaintVeil(_props) {
  return null;
}
